





























































































































































































































































































































































































































































































































































































































































import { Component, Vue, Watch, Inject } from "vue-property-decorator";
import axios from "axios";
import * as echarts from "echarts";
import selecttype from "../components/selectType.vue";
import position from "../components/position.vue";
import shouquan from "../components/shouquan.vue";
import myvideo from "../components/myvideo.vue";
import downLoadApp from "../components/downloadApp.vue";

import {
  chaijieDetail,
  levelRank,
  getCommenData,
  getVideoData,
  getcjxjData,
  getFlashData,
  getRate,
  getRateTF,
  getCity,
} from "../api/cjDetail";
import Video from "video.js";
import "video.js/dist/video-js.css";
import wxshare from "../components/share.vue";
import JQuery from "jquery";
import wx from "weixin-js-sdk";
@Component({
  components: {
    selecttype,
    position,
    shouquan,
    myvideo,
    wxshare,
    downLoadApp,
  },
})
export default class cjDetail extends Vue {
  @Inject("getUserToken") private getUserToken: any;
  $route: any;
  $store: any;
  $router: any;
  $cookie: any;
  $toast: any;
  downloadTF: any = false;

  reportId: any = 1000022; //1000022 1000717 1000209 1000261 1000281 1000301 1000321 1000322 1000323 1000324 1000477(图文) 1000715
  reportVersion: any = 1; //1  2
  val: number = 1;
  col: number = 2;
  starValue: number = 0;
  shareTipTF: any = false;
  rateTF: boolean = false;
  cityName: any = "";
  videoInfo: any = {};
  myVideoTF: boolean = false;
  positionTF: any = false;
  selectTypeTF: any = false;
  selectMsg: any = "";
  cjLoadingTF: boolean = true;
  loadingDivTF: boolean = false;
  dataItem: any[] = [];
  needDwonLoad: boolean = false;
  xjIndex: any = 0;
  cjxjIndex: any = -1;
  disassembleTF: boolean = false;
  pingfenSort: boolean = true;
  count: number[] = [1, 2, 3, 4, 5, 6];
  scoreArr: any[] = [];
  disVideo: any = null;
  cjDetailData: any = Object.create(null);
  rankDataLength: any = 0;
  rankData: any = {};
  pkcount: any[] = [];
  disassemble: any[] = [];
  scroeValue: any = 83;
  currentIndex: any = 0;
  isHasMore: boolean = true;
  cjxjTF: boolean = false;
  isLoading: boolean = false;
  listPlayer: any = "";
  timestamp: any = new Date().getTime();
  disVideoData: any[] = [];
  leidatuTF: boolean = false;
  page: any = 1;
  timer: any = "";
  sort: any = 1;
  pageSize: any = 10;
  totalPages: any = 1;
  videoCount: any = 1;
  disVideoList: any[] = [];
  commenList: any[] = [];
  commenData: any = {};
  cjxjData: any[] = [];
  levelId: any = "";
  thirdId: any = "";
  detailIndex: any = 0;
  shuaxinTF: boolean = false;
  tokenType: any = 0;
  pageNo: any = 1;
  progressOption: any = Object.create({
    radius: 50,
    strokeOutWidth: 20,
    backColor: "#d9d9d9",
    progressColor: "red",
  });
  xjData: any = {
    name: "",
    phone: "",
    provinceId: "",
    cityId: "",
    brandId: "",
    modelId: "",
    seriesId: "",
  };
  xdjInfo: any = {
    name: "",
    phone: "",
  };
  userAgent: any = "";
  xdjTF: boolean = false;
  cjxjList: any[] = [];
  token: any = "";
  source: any = 304;
  cityData: any = {};
  cjInfoData: any = {};
  BMap: any;
  wxShareUrl: any;
  mounted() {
    this.userAgent = navigator.userAgent.toLowerCase();
    this.reportId = this.$route.query.reportId;
    this.wxShareUrl = window.location.href;
    this.reportVersion = 1;
    this.token = window.localStorage.getItem("userToken");
    this.$nextTick(() => {
      this.getCjData(this.reportId, this.reportVersion);
    });
  }
  @Watch("$route.query.reportId")
  changeRoute(to: any, from: any) {
    if (this.$route.path == "/cjDetail") {
      //仅在当前页面生效
      if (to != from) {
        // this.$router.go(0)
        this.reportId = to;
        this.timestamp = new Date().getTime();
        this.disVideo = null;
        this.isHasMore = true;
        this.disassembleTF = false;
        this.commenList = [];
        this.disVideoList = [];
        this.page = 1;
        this.pageNo = 1;
        this.leidatuTF = false;
        this.getCjData(this.reportId, this.reportVersion); //重新加载数据
      }
    }
  }
  changeDownload(val: any) {
    this.downloadTF = val;
  }
  changeShare(val: any) {
    this.shareTipTF = val;
  }
  shareUrl() {
    if (this.userAgent.match(/MicroMessenger/i) == "micromessenger") {
      this.shareTipTF = true;
    } else {
      this.downloadTF = true;
    }
  }
  // 微信分享
  wxShareData(typeData: any) {
    if (this.userAgent.match(/MicroMessenger/i) == "micromessenger") {
      var that = this;
      typeData.desc = "你的好友邀请你一起欣赏 拆车坊精彩拆解";
      JQuery.ajax({
        type: "get",
        url: "http://reg.chexun.com/api/WeiXinInfo.ashx",
        cache: false,
        dataType: "jsonp",
        data: { url: that.wxShareUrl },
        jsonpCallback: "funcweixin",
        success: function (data: any) {
          wx.config({
            debug: false, // true开启调试模式,pc端会console.log手机端会alert
            appId: data.appId, // 必填，公众号的唯一标识，填自己的！
            timestamp: data.wxinfo.timestamp, // 必填，生成签名的时间戳，刚才接口拿到的数据
            nonceStr: data.wxinfo.nonceStr, // 必填，生成签名的随机串
            signature: data.wxinfo.signature, // 必填，签名，见附录1
            jsApiList: ["updateTimelineShareData", "updateAppMessageShareData"],
          });
          wx.ready(function () {
            //分享到朋友圈
            wx.updateTimelineShareData({
              title: typeData.reportName, // 分享时的标题
              link: that.wxShareUrl, // 分享时的链接
              imgUrl: typeData.cover, // 分享时的图标
              success: function () {
                console.log("分享成功");
              },
              cancel: function () {
                // alert("取消分享");
              },
            });
            //分享给朋友
            wx.updateAppMessageShareData({
              title: typeData.reportName,
              desc: typeData.desc,
              link: that.wxShareUrl,
              imgUrl: typeData.cover,
              success: function () {
                console.log("分享成功");
                //alert("分享成功");
              },
              cancel: function () {
                //alert("取消分享");
              },
            });
          });
        },
        error: function () {
          alert("error");
        },
      });
    }
  }
  //定位到当前城市
  getPosition() {
    let that = this;
    var geolocation = new BMap.Geolocation();
    geolocation.getCurrentPosition(function (r: any) {
      const myGeo = new BMap.Geocoder();
      myGeo.getLocation(
        new BMap.Point(r.point.lng, r.point.lat),
        (data: any) => {
          that.cityName = data.addressComponents.city;
          that.getCityId();
        }
      );
    });
  }
  // 获取城市id
  getCityId() {
    let params: any = {
      cityName: this.cityName,
    };
    getCity(params).then((res: any) => {
      //返回值
      this.cityData = res.data;
    });
  }
  openXzcs() {
    this.positionTF = true;
  }
  // 获取选中车型
  getSelectOne(value: any) {
    if (value) {
      this.cjInfoData.seriesId = value.seriesId;
      this.cjInfoData.brandId = value.brandId;
      this.cjInfoData.modelId = value.modelId;
      this.cjInfoData.totalName = value.modelName;
    }
    this.selectTypeTF = false;
  }
  // 获取选中城市
  getSelectCity(value: any) {
    if (value) {
      this.cityName = value.name;
      this.cityData.cityid = value.channelCity;
      this.cityData.provinceId = value.provinceId;
    }
    this.positionTF = false;
  }
  //跳转到选择车型
  goSelectType() {
    this.selectTypeTF = true;
  }
  //返回
  goBack() {
    this.$router.go(-1);
  }
  //跳转到首页
  goIndex() {
    this.$router.push("/");
  }
  //分享
  share() {}
  //接受video参数
  changeVideo(val: any) {
    this.myVideoTF = val;
  }
  //打开询底价弹框
  openXdj(params: any) {
    this.xdjTF = params;
    this.$nextTick(() => {
      this.getPosition();
    });
  }
  //提交询底价
  goOtherPage(){
    window.open('https://obs.3dyunzhan.com/sceneFront/index.html?G_TEMP_ID=805f56b4a12a4cd1881b36b194c712d6')
  }
  submitXdjData() {
    if (this.xdjInfo.name == "" || this.xdjInfo.phone == "") {
      this.$toast.text("姓名和手机号不能为空哦~");
    } else {
      this.xjData.brandId = this.cjInfoData.brandId;
      this.xjData.seriesId = this.cjInfoData.seriesId;
      this.xjData.modelId = this.cjInfoData.modelId;
      this.xjData.source = this.source;
      this.xjData.provinceId = this.cityData.provinceId;
      this.xjData.cityId = this.cityData.cityid;
      this.xjData.name = this.xdjInfo.name; 
      this.xjData.phone = this.xdjInfo.phone;
      let param = new URLSearchParams();
      param.append("name", this.xdjInfo.name);
      param.append("phone", this.xdjInfo.phone);
      param.append("cityId", this.xjData.cityId);
      param.append("provinceId", this.xjData.provinceId);
      param.append("brandId", this.xjData.brandId);
      param.append("modelId", this.xjData.modelId);
      param.append("seriesId", this.xjData.seriesId);
      param.append("source", this.source);
      axios({
        headers: {
          "Content-Type": "application/x-www-form-urlencoded",
        },
        method: "post",
        url: "http://dealer.chexun.com/api/addEnquiry2.aspx",
        data: param,
      }).then((res: any) => {
        this.$toast.text(res.data.msg);
        this.xdjTF = false;
      });
    }
  }
  // 跳转到拆解项评分
  goCjScore() {
    this.$router.push({
      name: "cjScore",
      params: {
        cjData: this.cjDetailData,
      },
    });
  }
  //监听评分改变事件
  onChangeStar(value: any) {
    if (!this.token) {
      this.getUserToken();
    } else {
      let params: any = {
        reportId: this.reportId,
        dataId: value,
        tokenType: this.tokenType,
        token: this.token,
        type: "2",
      };
      getRate(params).then((res: any) => {
        //返回值
        this.rateTF = true;
        this.$toast.text(res.msg);
      });
    }
  }
  //跳转到车系页
  goSeriesPage() {
    window.location.href =
      "http://m.chexun.com/app/appseries#/?seriesId=" +
      this.cjDetailData.seriesId;
  }
  //跳转到详情页
  goCjDetail(item: any, index: any) {
    if (this.detailIndex != index) {
      this.detailIndex = index;
      this.$router.push({
        path: "/cjDetail",
        query: {
          reportId: item.reportId,
        },
      });
      // this.$router.push({
      //   path: "/blank",
      //   query: {
      //     reportId: item.reportId,
      //     reportVersion: item.reportVersion,
      //   },
      // });
    }
  }
  delectCjxjList() {
    this.cjxjList = [];
    this.timestamp = new Date().getTime();
    this.commenList = [];
    this.disVideoList = [];
    this.isHasMore = true;
    this.levelId = "";
    this.thirdId = "";
    this.page = 1;
    this.pageNo = 1;
    this.getDisVideoData();
  }
  //拆解细节内容
  changeCjxjIndex(index: any, item: any) {
    this.cjxjList = [];
    this.cjxjIndex = index;
    this.timestamp = new Date().getTime();
    this.commenList = [];
    this.disVideoList = [];
    this.isHasMore = true;
    this.levelId = item.level;
    this.thirdId = item.thirdId;
    this.page = 1;
    this.pageNo = 1;
    this.getDisVideoData();
    this.cjxjList.push(item.thirdName);
  }
  //提示下载APP
  goDownLoadApp(data: any) {
    if (data == 1) {
      if (this.userAgent.match(/Android/i) == "android") {
        window.location.href =
          "https://a.app.qq.com/o/simple.jsp?pkgname=com.chexun.platform";
      } else {
        //ios
        window.location.href =
          "itms-apps://apps.apple.com/cn/app/%E8%BD%A6%E8%AE%AF%E7%BD%91/id577675997";
      }
    } else {
      let that = this as any;
      that.$toast.text("需要下载APP才能操作哦");
      this.needDwonLoad = true;
    }
  }
  //拆解细节tab选项
  changeTabIndex(index: any) {
    this.xjIndex = index;
  }
  //关闭拆解细节弹窗
  closeCjxj() {
    this.cjxjTF = false;
  }
  //获取拆解细节数据
  getcjxj() {
    // this.goDownLoadApp(null);
    let params: any = {
      reportId: this.reportId,
      token: "",
    };

    getcjxjData(params).then((res: any) => {
      //返回值
      this.cjxjData = res.data.data;
      this.cjxjTF = true;
      for (let y in this.cjxjData) {
        if (this.cjxjData[y].thirdList.length != 0) {
          let all: any = {
            thirdName: "全部",
            thirdId: "",
            level: "",
            thirdScore: "",
          };
          all.thirdId = this.cjxjData[y].firstId;
          all.level = this.cjxjData[y].level;
          all.thirdScore = this.cjxjData[y].firstScore;
          this.cjxjData[y].thirdList.unshift(all);
        }
      }
      for (let i in this.cjxjData) {
        if (this.cjxjData[i].thirdList.length != 0) {
          this.xjIndex = i;
          return;
        }
      }
    });
  }
  //评分
  getScoreData(idx: any) {
    if (idx == 10) {
      this.sort = 3;
      this.pingfenSort = false;
    } else if (idx == 11) {
      this.sort = 4;
      this.pingfenSort = true;
    }
    this.currentIndex = 2;
    this.page = 1;
    this.pageNo = 1;

    this.isHasMore = true;
    this.disVideoList = [];
    this.getDisVideoData();
  }
  //推荐
  goRecommend() {
    this.currentIndex = 0;
    this.sort = 1;
    this.page = 1;
    this.pageNo = 1;

    this.timestamp = new Date().getTime();
    this.commenList = [];
    this.disVideoList = [];
    this.isHasMore = true;
    if (this.disVideo) {
      this.getDisVideoData();
    } else {
      this.getRecommendData();
    }
  }
  //热度
  getHotData() {
    this.currentIndex = 1;
    this.sort = 2;
    this.page = 1;
    this.pageNo = 1;
    this.timestamp = new Date().getTime();
    this.commenList = [];
    this.disVideoList = [];
    this.isHasMore = true;
    if (this.disVideo) {
      this.getDisVideoData();
    } else {
      this.getRecommendData();
    }
  }

  scroll(scrollData: any) {}
  //加载更多数据
  loadmoreData(index: any) {
    if (this.disVideo && this.isHasMore) {
      if (this.disVideoList.length >= this.videoCount) {
        this.timer = setTimeout(() => {
          this.isHasMore = false;
        }, 1000);
      } else {
        this.getDisVideoData();
      }
    }
  }
  //获取拆解视频数据
  getDisVideoData() {
    let params: any = {
      reportId: this.reportId,
      reportVersion: this.reportVersion,
      sort: this.sort,
      pageSize: this.pageSize,
      pageNo: this.pageNo,
      classType: 13,
      token: this.token,
    };
    if (this.levelId != "") {
      params.level = this.levelId;
      params.levelid = this.thirdId;
    }
    getVideoData(params).then((res: any) => {
      //返回值
      this.cjxjTF = false;
      if (res.data.list.length < 10) {
        if (
          this.disVideoList.length != 0 &&
          this.disVideoList[0].id == res.data.list[0].id
        ) {
          this.disVideoList = this.disVideoList;
        } else {
          this.disVideoList = this.disVideoList.concat(res.data.list);
        }
        setTimeout(() => {
          this.isHasMore = false;
        }, 1000);
      } else {
        this.disVideoData = res.data.list;
        this.videoCount = res.data.count;
        if (
          this.disVideoList.length != 0 &&
          this.disVideoList[0].id == res.data.list[0].id
        ) {
          this.disVideoList = this.disVideoList;
        } else {
          this.disVideoList = this.disVideoList.concat(res.data.list);
          this.pageNo += 1;
        }
      }
    });
  }
  //拆解视频打开视频播放器
  goDetail(item: any, index: any) {
    this.myVideoTF = true;
    this.videoInfo = item;
  }
  //跳转到视频文章详情
  goDetailPage(item: any) {
    let detailTime;
    if (item.creationTime) {
      detailTime = item.creationTime.substring(0, 10);
    } else {
      detailTime = item.createTime.substring(0, 10);
    }
    this.$router.push({
      path: `/${detailTime}/${item.id}.html`,
    });
  }
  //获取拆解报告
  getCjData(reportId: any, reportVersion: any) {
    this.scoreArr = [];
    this.pkcount = [];
    let params: any = {
      reportId: reportId,
      reportVersion: reportVersion,
      tokenType: this.tokenType,
      token: this.token,
    };
    chaijieDetail(params).then((res: any) => {
      //返回值
      this.cjLoadingTF = false;
      this.cjDetailData = res.data;
      this.wxShareData(this.cjDetailData);
      this.cjInfoData = res.data;
      this.rateTF = this.cjDetailData.userVote;
      this.starValue = this.cjDetailData.evaluating;
      this.selectMsg = this.cjDetailData.seriesId;
      this.cjDetailData.totalName =
        this.cjDetailData.years + "" + this.cjDetailData.modelName;
      document.title =
        this.cjDetailData.seriesName +
        " " +
        this.cjDetailData.years +
        " " +
        this.cjDetailData.modelName;
      this.disVideo = this.cjDetailData.disVideo;
      if (this.disVideo == true) {
        this.page = 1;
        this.getDisVideoData();
      } else {
        this.page = 1;
        this.getRecommendData();
      }
      this.cjDetailData.cover = this.cjDetailData.cover.replace(
        /(i\d).chexun.net/g,
        "img1.chexun.com"
      );
      this.cjDetailData.finishYear = this.cjDetailData.finishTime.split("-")[1];
      this.cjDetailData.finishMonth =
        this.cjDetailData.finishTime.split("-")[2];
      this.pkcount = res.data.firstScore;
      for (let i = 0; i < res.data.firstScore.length; i++) {
        this.scoreArr.push(res.data.firstScore[i].firstScore);
      }
      if (this.reportVersion == 1) {
        this.leidatuTF = true;
        this.$nextTick(() => {
          this.getRadar(res.data, this.scoreArr);
        });
      } else {
        this.scroeValue = res.data.score;
        this.getProgress(res.data);
      }
      this.getRank(this.cjDetailData);
      this.getFlash(this.cjDetailData.modelId);
    });
  }
  //获取同级别排名
  getRank(cjDetailData: any) {
    let params: any = {
      seriesId: cjDetailData.seriesId,
    };
    levelRank(params).then((res: any) => {
      if (JSON.stringify(res.data) == "{}") {
        this.rankDataLength = 0;
      } else {
        this.rankData = res.data;
        this.detailIndex = this.rankData.ranking - 1;
        for (let i in this.rankData.list) {
          this.rankData.list[i].clubCover = this.rankData.list[
            i
          ].clubCover.replace(/(i\d).chexun.net/g, "img1.chexun.com");
        }
        this.rankDataLength = res.data.list.length;
      }
    });
  }
  //获取亮点综述
  getFlash(modelId: any) {
    let that = this;
    let params = {
      type: 2,
      modelId,
    };
    getFlashData(params).then((res: any) => {
      this.disassemble = res.data.disassemble[0];
      if (res.data.disassemble != "") {
        this.disassembleTF = true;
      }
    });
  }
  //加载雷达图
  getRadar(data: any, scoreArr: any[]) {
    var myChart: any = echarts.init(
      document.getElementById("main") as HTMLElement
    );
    // 指定图表的配置项和数据
    var i: number = -1;
    var option: any = {
      title: {
        left: "center",
        top: "center",
        text: `{a|${data.score}}{b|分}`,
        textStyle: {
          rich: {
            a: {
              fontSize: "25px",
              fontWeight: 700,
              color: "rgba(52, 64, 88, 1)",
            },
            b: {
              fontSize: 14,
              fontWeight: 700,
              color: "rgba(52, 64, 88, 1)",
            },
          },
        },
      },
      radar: [
        {
          indicator: [
            { text: "", max: 100 },
            { text: "", max: 100 },
            { text: "", max: 100 },
            { text: "", max: 100 },
            { text: "", max: 100 },
            { text: "", max: 100 },
          ],
          center: ["50%", "50%"], //位置
          radius: "68%",
          startAngle: 90,
          splitNumber: 7,
          shape: "polygon",
          nameGap: 5,
          name: {
            rich: {
              a: {
                color: "rgba(52, 64, 88, 1)",
                fontSize: 13,
                fontWeight: "bold",
                align: "center",
              },
              b: {
                color: "rgba(244, 59, 25, 1)",
                fontSize: 13,
                fontWeight: "bold",
                align: "center",
              },
              c: {
                color: "rgba(149, 165, 180, 1)",
                fontSize: 9,
                fontWeight: "500",
                lineHeight: 12,
              },
            },
            formatter: (a: any, b: any, c: any) => {
              i++;
              if (this.pkcount[i].firstScore > 100) {
                this.pkcount[i].firstScore = 100;
              }
              if (this.pkcount[i].firstScore < 0) {
                this.pkcount[i].firstScore = 0;
              }
              if (
                this.pkcount[i].calcstatus == true &&
                this.pkcount[i].showState == 1
              ) {
                return `{a|${this.pkcount[i].firstName}}{b| ${this.pkcount[i].firstScore}}\n{c|击败${this.pkcount[i].pkValues}%的车}`;
              } else if (this.pkcount[i].showState == 0) {
                return `{a|${this.pkcount[i].firstName}}\n{c|未测评}`;
              } else {
                if (
                  this.pkcount[i].firstScore == 0 &&
                  this.cjDetailData.flowStatus == 3
                ) {
                  return `{a|${this.pkcount[i].firstName}}{b| ?}`;
                } else {
                  return `{a|${this.pkcount[i].firstName}}{b| ${this.pkcount[i].firstScore}}`;
                }
              }
            },
          },
          splitArea: {
            areaStyle: {
              color: [
                "rgba(250, 250, 250, 1)",
                "rgba(250, 250, 250, 1)",
                "rgba(208, 219, 242, 0.6)",
                "rgba(174,190, 224, 0.75)",
                "rgba(195,211, 241, 1)",
                "rgba(217,231,254, 1)",
                "rgba(228,236,251, 0.75)",
              ],
              // shadowColor: 'rgba(70, 77, 88, 0.4)',
              // shadowBlur: 10
            },
          },
          axisLine: {
            lineStyle: {
              color: "rgba(255, 255, 255, 0)",
            },
          },
          splitLine: {
            lineStyle: {
              color: "rgba(255, 255, 255, 0)",
            },
          },
        },
      ],
      series: [
        {
          name: "雷达图",
          type: "radar",
          emphasis: {
            lineStyle: {
              width: 0,
            },
          },
          lineStyle: {
            width: 0,
          },

          data: [
            {
              value: scoreArr,
              name: "车辆维度图",
              symbolSize: 0,
              areaStyle: {
                color: "rgba(170, 174, 213, 1)",
              },
              itemStyle: {
                color: "rgba(159, 178, 215, 0)",
              },
              labelLine: {
                show: false,
              },
            },
          ],
        },
      ],
    };
    if (this.cjDetailData.flowStatus == 3) {
      option.title.text = "拆解中";
      option.title.textStyle.fontSize = "14px";
    }
    // 使用刚指定的配置项和数据显示图表。
    //@ts-ignore
    myChart.setOption(option);
  }
  //加载圆弧进度条
  getProgress(data: any) {
    // let cjScoreProgress:any = this.$refs.cjScoreProgress;
    // let percent:any = 0;
    // cjScoreProgress.style.transform = `rotate(${percent}deg)`
    const trackW = 80;
    const rx = 425;
    const ry = 300;
    const radius = 250;
    const innerLineW = 80;
    let that = this;
    const canvas: any = document.getElementById(
      "cjScore-canvas"
    ) as HTMLInputElement;
    const ctx = canvas.getContext("2d");
    function draw(toAngle: any, currentAngle = Math.PI) {
      ctx.clearRect(0, 0, canvas.width, canvas.height);
      // 半圆轨道
      ctx.beginPath();
      ctx.strokeStyle = "rgba(233, 238, 245, 1)";
      ctx.lineWidth = trackW;
      ctx.arc(rx, ry, radius, Math.PI, 0, false);
      ctx.stroke();
      // 圆弧
      ctx.beginPath();
      ctx.lineCap = "butt";
      ctx.strokeStyle = "rgba(172, 187, 217, 1)";
      ctx.lineWidth = innerLineW;
      ctx.arc(rx, ry, radius, Math.PI, currentAngle, false);
      ctx.stroke();
      if (currentAngle < toAngle) {
        currentAngle += 0.02;
        if (currentAngle > toAngle) currentAngle = toAngle;
        requestAnimationFrame(() => {
          draw(toAngle, currentAngle);
        });
      }
      ctx.font = "600 70px DINAlternate";
      ctx.fillText(that.scroeValue, 380, 270);
      ctx.font = "40px DINAlternate";
      ctx.fillText("分", 430, 265);

      // ctx.lineWidth = 1;
      // ctx.strokeStyle = "#444";
      // ctx.beginPath();
      // ctx.moveTo(0, 0);
      // ctx.lineTo(300, 150);
      // ctx.arc(rx, ry, radius, Math.PI, currentAngle, false);

      // ctx.stroke();
    }
    // draw(1.5 * Math.PI);
    data.score = data.score * 10;
    const angle =
      ((data.score > 100 ? 100 : data.score < 0 ? 0 : data.score) / 100) * 180;
    draw(((angle + 180) / 180) * Math.PI);
  }
  //获取推荐数据
  getRecommendData() {
    this.commenData = {};
    let params: any = {
      reportId: this.reportId,
      reportVersion: this.reportVersion,
      sort: 1,
      ps: this.pageSize,
      pn: this.page,
    };
    getCommenData(params).then((res: any) => {
      //返回值
      this.videoCount = res.data.count;
      this.commenList = this.commenList.concat(res.data.list);
      if (res.data.count % 10 === 0) {
        this.totalPages = res.data.count / 10;
      } else {
        let numberOne: any = res.data.count / 10;
        this.totalPages = parseInt(numberOne) + 1;
      }
      if (this.totalPages == 1) {
        this.isHasMore = false;
      }
    });
  }
  //图文视频数据无限加载
  onInfinite() {
    this.isLoading = true;
    this.timer = setTimeout(() => {
      if (this.page < this.totalPages) {
        this.page = this.page + 1;
        this.getRecommendData();
      } else {
        this.isHasMore = false;
      }
      this.isLoading = false;
    }, 100);
  }
  destroyed() {
    clearTimeout(this.timer);
  }
}
